import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ConfigurationsJobFamiliesService from "../../../../services/api/configurations/ConfigurationsJobFamilies.service";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { UpdateJobFamiliesConfig } from "../../../../types/api/configurations.type";
import { useEffect } from "react";

const MANAGE_JOB_FAMILY_QUERY_KEY = "get-config-job-families";

export const useManageJobFamilies = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: [MANAGE_JOB_FAMILY_QUERY_KEY, configYear],
    queryFn: () => ConfigurationsJobFamiliesService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateManageJobFamilies = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["update-manage-job-families"],
    mutationFn: (result: UpdateJobFamiliesConfig) =>
      ConfigurationsJobFamiliesService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_JOB_FAMILY_QUERY_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`errore updating job families config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });
  return { mutate, isPending };
};
